import { useQuery } from '@tanstack/react-query';
import { useTacticHooks } from '../providers/TacticHooksProvider';
import { PageFilter } from '@gettactic/api';

export const usePagesQuery = (filter?: PageFilter) => {
  const { apiClient } = useTacticHooks();
  const sections = useQuery({
    queryKey: ['usePageQuery', apiClient.slug, filter],

    queryFn: async () => {
      const res = await apiClient.pages.getPages();
      return res.result;
    },

    enabled: !!apiClient.slug
  });

  return sections.data;
}
